import React, { memo, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { createGlobalStyle } from 'styled-components';
import { fetchNftDetail } from "../../store/actions/thunks";
import * as selectors from '../../store/selectors';
import Checkout from "../components/Checkout";
import Clock from "../components/Clock";
import Footer from '../components/footer';
import { navigate } from "@reach/router";
import axios from "axios";
import Getconfig from '../../config';
export const {
    websiteUrl, apiUrl
} = Getconfig();

const GlobalStyles = createGlobalStyle`
  header#myHeader.navbar.white {
    background: #212428;
  }
`;

const ItemDetailRedux = () => {

    const [openMenu, setOpenMenu] = React.useState(true);
    const [openMenu1, setOpenMenu1] = React.useState(false);
    const handleBtnClick = () => {
        setOpenMenu(!openMenu);
        setOpenMenu1(false);
        document.getElementById("Mainbtn").classList.add("active");
        document.getElementById("Mainbtn1").classList.remove("active");
    };
    const handleBtnClick1 = () => {
        setOpenMenu1(!openMenu1);
        setOpenMenu(false);
        document.getElementById("Mainbtn1").classList.add("active");
        document.getElementById("Mainbtn").classList.remove("active");
    };

    const dispatch = useDispatch();
    const nftDetailState = useSelector(selectors.nftDetailState);
    const nft = nftDetailState.data ? nftDetailState.data : [];

    const [openCheckout, setOpenCheckout] = React.useState(false);

    // test start
    async function fetchClick(currentTokenId, new_copy) {
        try {
            const result = await axios.get(`${apiUrl}/api/v1/get_nft_token?nft_token_id=${currentTokenId}&sell_id=${currentTokenId}&current_copy=${new_copy}`);
            console.log(result);
            if (result.data["status"] === "success") {
                const count = (result.data['data'][0].clicks);
                const royalty = (result.data['data'][0].royalty);
                const royalty_address = (result.data['data'][0].royalty_address);
                const collection_id = (result.data['data'][0].collection_id);
                const collection_name = (result.data['data'][0].collection_name);
                const collection_desc = (result.data['data'][0].collection_desc);
                const collection_logo = (result.data['data'][0].collection_logo);
            }
        } catch (error) {
            console.error(error);
        }
    }
    // test end

    useEffect(() => {
        dispatch(fetchNftDetail());
    }, [dispatch]);

    useEffect(() => {
        fetchClick('10', '1');
    }, []);

    return (
        <div>
            <GlobalStyles />
            <section className='container'>
                <div className='row mt-md-5 pt-md-4'>
                    <div className="col-md-6 text-center">
                        <img src="./img/items/big-1.jpg" className="img-fluid img-rounded mb-sm-30" alt="" />
                    </div>
                    <div className="col-md-6">
                        <div className="item_info">
                            Auctions ends in
                            <div className="de_countdown">
                                <Clock deadline={nft.item_deadline} />
                            </div>
                            <h2>{nft.item_title}</h2>
                            <div className="item_info_counts">
                                <div className="item_info_type"><i className="fa fa-image"></i>{nft.item_category}</div>
                                <div className="item_info_views"><i className="fa fa-eye"></i>{nft.item_views}</div>
                                <div className="item_info_like"><i className="fa fa-eye"></i>{nft.item_likes}</div>
                            </div>
                            <p>{nft.item_description}</p>
                            {/* button untuk checkout */}
                            <button className='btn-main lead mb-5' onClick={() => setOpenCheckout(true)}>Checkout</button>

                            <h6>Creator</h6>
                            <div className="item_author">
                                <div className="author_list_pp">
                                    <span>
                                        <img className="lazy" src={nft.author && nft.author.avatar} alt="" />
                                        <i className="fa fa-check"></i>
                                    </span>
                                </div>
                                <div className="author_list_info">
                                    <span>{nft.author && nft.author.username}</span>
                                </div>
                            </div>

                            <div className="spacer-40"></div>

                            <div className="de_tab">

                                <ul className="de_nav">
                                    <li id='Mainbtn' className="active"><span onClick={handleBtnClick}>Bids</span></li>
                                    <li id='Mainbtn1' className=''><span onClick={handleBtnClick1}>History</span></li>
                                </ul>

                                <div className="de_tab_content">
                                    {openMenu && (
                                        <div className="tab-1 onStep fadeIn">
                                            {nft.bids && nft.bids.map((bid, index) => (
                                                <div className="p_list" key={index}>
                                                    <div className="p_list_pp">
                                                        <span>
                                                            <img className="lazy" src={bid.avatar} alt="" />
                                                            <i className="fa fa-check"></i>
                                                        </span>
                                                    </div>
                                                    <div className="p_list_info">
                                                        Bid {bid.is_author && 'accepted'} <b>{bid.value} NEAR</b>
                                                        <span>by <b>{bid.username}</b> at {bid.timestamp}</span>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    {openMenu1 && (
                                        <div className="tab-2 onStep fadeIn">
                                            {nft.history && nft.history.map((bid, index) => (
                                                <div className="p_list" key={index}>
                                                    <div className="p_list_pp">
                                                        <span>
                                                            <img className="lazy" src={bid.avatar} alt="" />
                                                            <i className="fa fa-check"></i>
                                                        </span>
                                                    </div>
                                                    <div className="p_list_info">
                                                        Bid {bid.is_author && 'accepted'} <b>{bid.value} NEAR</b>
                                                        <span>by <b>{bid.username}</b> at {bid.timestamp}</span>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
            {openCheckout &&
                <div className='checkout'>
                    <Checkout />
                    <button className='btn-close' onClick={() => setOpenCheckout(false)}>x</button>
                </div>
            }
        </div>
    );
}

export default memo(ItemDetailRedux);